<template>
    <div class="publication" v-if="publication">
        <div class="cover">
            <div class="filler"></div>
            <Image :image="publication.cover" :height="400" :width="400" :mobileHeight="824" imageClass="cover" />
        </div>
        <div class="info">
            <div class="date baron headerText" v-if="articleDate">
                <span>{{ articleDate.getDate().toString().padStart(2, '0') }}</span>
                <span>{{ (articleDate.getMonth() + 1).toString().padStart(2, '0') }}</span>
                <span>{{ articleDate.getFullYear() }}</span>
            </div>
            <div class="helvetica title5">{{ publication.title }}</div>
        </div>
        <div class="downloadLink" v-if="downloadable"><span class="title6 helvetica">Download</span>
            <IconDownload />
        </div>
        <div class="readLink" v-else><span class="title6 helvetica">Details</span> →</div>

        <NuxtLink class="overlink" :to="`${directusUrl}/assets/${publication.attachment.id}`" target="_blank" :external="true" v-if="downloadable && publication.attachment"></NuxtLink>
        <NuxtLink class="overlink" :to="{ name: page_url, params: { slug: publication.url } }" v-else-if="!downloadable && page_url"></NuxtLink>
    </div>
</template>

<script lang="ts" setup>
const directusUrl = useDirectusUrl()
const props = defineProps<{ publication: any, page_url?: string }>()

const articleDate = computed(() => {
    if (props.publication && props.publication.publication_date) return new Date(props.publication.publication_date)
    else return null
})
const downloadable = computed(() => {
    if (props.publication && (props.publication.type == 'position_paper' || props.publication.type == 'statistic') || props.publication.type == 'annual_report') return true
    else return false
})
</script>

<style lang="scss" scoped>
.publication {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-default);

    .cover {
        width: 100%;
        background-color: #fafafa;
        position: relative;

        .filler {
            padding-top: 100%;
        }

        &:deep(.responsivePicture) {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        gap: var(--size-gutter-small);

        .title5 {
            text-wrap: balance;
        }

        .date {
            display: flex;
            gap: var(--size-gutter-small);
            color: var(--color-primary);
        }
    }

    .downloadLink {
        color: var(--color-primary);

        &:deep(svg) {
            height: 12px;
            width: 12px;
            margin-left: 6px;
        }
    }

    .readLink {
        color: var(--color-primary);
    }
}
</style>